/* ZCT_V22_PRODUKT (E4): Produktseite wie PDP in v21 (JS-025 bis JS-031).
   - Galerie: Vorschaubilder, Wisch-Spur mit Einrasten, Zähler, Punkte; Bilder nur für die aktive Folie und ihre Nachbarn,
     sonst Ersatzfläche; nächstes Bild 500 ms nach dem Wechsel vorladen (link rel=preload, 720 px); aktives Vorschaubild
     sichtbar scrollen (smooth, nearest)
   - Zoom: Maus über dem Hauptbild zeigt .pdp-zoom (Hintergrund 2000 px, 200 %, Position der Maus)
   - Lightbox: Klick auf Folie oder Raumbild; Escape, Pfeiltasten, Wischen (40 px), Klick daneben schließt; Body ohne Scrollen
   - Oberfläche (Raster und Handy-Regler) und Größe: Variante, Preis, Bilder, Texte wie v21; nicht lieferbare Größe gesperrt;
     Wechsel setzt die Galerie ohne Animation auf Bild 1
   - Menge, In den Warenkorb (zctLaden.add: Schublade nach Bildladen, spätestens 300 ms), Merken, Aufklapper (immer einer offen
     oder keiner), Termin (zctTermin, JS-041) */
(function () {
  'use strict';
  function zctT(k) { try { var el = document.getElementById('zct-texte'), d = el ? JSON.parse(el.textContent) : {}; var v = d[k]; if (typeof v === 'string' && v.indexOf('&') >= 0) { var t = document.createElement('textarea'); t.innerHTML = v; v = t.value; } return v == null ? '' : v; } catch (e) { return ''; } }
  function ent(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function url(basis, w) { if (!basis) return basis; if (!/(?:cdn\.shopify\.com|\/cdn\/shop\/)/.test(basis)) return basis; return basis + (basis.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function satz(basis, ws) { return ws.map(function (w) { return url(basis, w) + ' ' + w + 'w'; }).join(', '); }
  function schluessel(u) { var i = u.indexOf('/files/'); if (i >= 0) return 'files/' + u.slice(i + 7); i = u.indexOf('/assets/'); if (i >= 0) return 'assets/' + u.slice(i + 8).replace(/\?v=\d+$/, ''); return u; }
  var PFEIL = '<svg class="ico " viewBox="0 0 16 16"><path d="M3 8h10m-4-4l4 4-4 4"></path></svg>';

  class ZctProdukt extends HTMLElement {
    connectedCallback() {
      if (this._zct) return; this._zct = true;
      var el = this;
      var D; try { D = JSON.parse(this.querySelector('#zct-pdp-daten').textContent); } catch (e) { return; }
      var L = window.zctLaden || {};
      var fmt = function (cent) { return L.fmt ? L.fmt(cent / 100) : String(cent / 100); };
      var toene = D.toene && D.toene.length ? D.toene : [D.ton];
      var st = { img: 0, finish: 0, size: 0, qty: 1, open: 'desc', lightbox: false };
      var sizeBtns = Array.prototype.slice.call(el.querySelectorAll('.size-grid .size'));
      st.size = Math.max(0, sizeBtns.findIndex(function (b) { return b.classList.contains('on'); }));

      // ---------- Ableitungen wie in der PDP von v21 ----------
      function ton() { return toene[st.finish] || D.ton; }
      function groesse() { return D.groessen[st.size] || D.groessen[0]; }
      // Größe passt, wenn Shopifys Wert dem deutschen Schlüssel oder dem Namen in der Seitensprache (kShop) entspricht
      function passtGroesse(v, g) {
        return [g.k, g.kShop].some(function (k) { return k && (v.o1 === k || v.t === k || String(v.t || '').indexOf(String(k) + ' /') === 0); });
      }
      function passtTon(v, t) {
        var w = ((v.o1 || '') + ' ' + (v.o2 || '') + ' ' + (v.t || '')).toLowerCase();
        var MESSING = ['messing', 'brass', 'laiton', 'latón', 'ottone'], STAHL = ['edelstahl', 'stainless', 'steel', 'acier', 'acero', 'acciaio'];
        var hat = function (l) { return l.some(function (x) { return w.indexOf(x) >= 0; }); };
        var mat = hat(MESSING) || hat(STAHL);
        if (!mat) return true;
        return t === 'brass' ? hat(MESSING) : hat(STAHL);
      }
      function variante() {
        var t = ton(), g = groesse();
        return D.varianten.find(function (v) { return passtGroesse(v, g) && passtTon(v, t); }) || D.varianten.find(function (v) { return passtTon(v, t); }) || null;
      }
      function bilder() {
        var t = ton(), v = variante(), vb = v && v.bild ? v.bild : null;
        var seen = {}, liste = [];
        var add = function (src) { if (!src) return; var k = schluessel(src); if (seen[k]) return; seen[k] = 1; liste.push(src); };
        if (vb) add(vb);
        var tg = D.galerien[t] || [];
        if (tg.length) tg.forEach(function (e, i) { if (i === 0 && vb && D.erstesErsetzt) return; add(e); });
        else { var skip = !!(vb && D.erstesErsetzt); if (!skip) add(D.bild); (D.galerie || []).forEach(function (e, i) { if (i === 0 && skip) return; add(e); }); }
        return liste;
      }
      function preis() { // in Cent wie variantPrice * qty
        var v = variante(); var p = v ? v.preis : (groesse().preise[ton()] != null ? groesse().preise[ton()] * 100 : null);
        return p == null ? null : p * st.qty;
      }
      function einzelpreis() { var v = variante(); return v ? v.preis : (groesse().preise[ton()] != null ? groesse().preise[ton()] * 100 : null); }
      function alt(i) {
        if (i > 0) return D.name + ': ' + ent(D.ui.detail) + ' ' + (i + 1);
        var text = ent(D.ui.alt0), names = D.namen || {};
        var current = names[ton()], other = names[ton() === 'brass' ? 'steel' : 'brass'];
        return current && other ? text.replace(ent(other), ent(current)) : text;
      }

      // ---------- Galerie ----------
      var thumbs = el.querySelector('.gallery .thumbs');
      var mainImg = el.querySelector('.main-img');
      var scroller = el.querySelector('.pdp-scroll');
      var track = el.querySelector('.pdp-scroll-track');
      var hinweis = el.querySelector('.pdp-expand-hint');
      var aktuelle = bilder();
      function phHtml(src, opt) {
        if (src) return '<div class="ph has-img "><img src="' + esc(url(src, opt.max)) + '" srcset="' + esc(satz(src, opt.breiten)) + '" sizes="' + opt.sizes + '" alt="' + esc(opt.alt || opt.label || '') + '" loading="' + (opt.loading || 'lazy') + '"' + (opt.prio ? ' fetchpriority="' + opt.prio + '"' : '') + ' decoding="async" referrerpolicy="no-referrer"></div>';
        return '<div class="ph ' + esc(ton()) + ' ">' + (opt.label ? '<div class="label">' + esc(opt.label) + '</div>' : '') + (opt.center ? '<div class="centerlabel">' + esc(opt.center) + '</div>' : '') + '</div>';
      }
      // Bildfläche an Ort und Stelle ändern (wie React: gleiches img, neue Adresse), Wechsel Bild ↔ Ersatz durch Austausch
      function phSetzen(huelle, src, opt) {
        var alt0 = huelle.firstElementChild;
        var hatBild = alt0 && alt0.classList.contains('has-img');
        if (src && hatBild) {
          var im = alt0.querySelector('img');
          var s1 = url(src, opt.max), s2 = satz(src, opt.breiten), a = opt.alt || opt.label || '';
          if (im.getAttribute('src') !== s1) im.setAttribute('src', s1);
          if (im.getAttribute('srcset') !== s2) im.setAttribute('srcset', s2);
          if (im.getAttribute('alt') !== a) im.setAttribute('alt', a);
          if (opt.loading && im.getAttribute('loading') !== opt.loading) im.setAttribute('loading', opt.loading);
          if (opt.prio) { if (im.getAttribute('fetchpriority') !== opt.prio) im.setAttribute('fetchpriority', opt.prio); }
          return;
        }
        if (!src && alt0 && !hatBild) {
          var k = 'ph ' + ton() + ' '; if (alt0.className !== k) alt0.className = k;
          var h = (opt.label ? '<div class="label">' + esc(opt.label) + '</div>' : '') + (opt.center ? '<div class="centerlabel">' + esc(opt.center) + '</div>' : '');
          if (alt0.innerHTML !== h) alt0.innerHTML = h;
          return;
        }
        var tmp = document.createElement('div'); tmp.innerHTML = phHtml(src, opt);
        if (alt0) alt0.replaceWith(tmp.firstChild); else huelle.appendChild(tmp.firstChild);
      }
      function folienOpt(i) {
        var nr = String(i + 1); if (nr.length < 2) nr = '0' + nr;
        return { max: 2000, breiten: [480, 720, 960, 1200, 1600, 2000], sizes: '(max-width: 900px) 100vw, 58vw', alt: alt(i), loading: i === st.img ? 'eager' : 'lazy', prio: i === st.img ? 'high' : 'auto',
          label: i === 0 ? D.mono : null, center: D.name + ' · ' + ent(D.ui.ansichtGross) + ' ' + nr };
      }
      var folienSchluessel = aktuelle.map(function (s, i) { return s + '-' + i; }).join('|');
      function galerieZeichnen(neueListe) {
        var liste = aktuelle;
        // Vorschaubilder (Index-Schlüssel: Knöpfe bleiben, Bilder wechseln an Ort und Stelle)
        while (thumbs.children.length > liste.length) thumbs.lastElementChild.remove();
        liste.forEach(function (src, i) {
          var b = thumbs.children[i];
          var k = st.img === i ? 'on' : '';
          if (!b) { b = document.createElement('button'); b.className = k; thumbs.appendChild(b); b.addEventListener('click', function () { gehe(Array.prototype.indexOf.call(thumbs.children, b)); }); }
          if (b.className !== k || !b.hasAttribute('class')) b.className = k;
          phSetzen(b, src, { max: 288, breiten: [96, 144, 192, 288], sizes: '72px', alt: alt(i), loading: 'lazy', prio: 'low' });
        });
        // Folien (Schlüssel Adresse + Index: bei neuer Liste neu, sonst nur Bild bzw. Ersatz je nach Nähe zur aktiven Folie)
        var sk = liste.map(function (s, i) { return s + '-' + i; }).join('|');
        if (neueListe || sk !== folienSchluessel) {
          folienSchluessel = sk;
          track.innerHTML = liste.map(function (src, i) { return '<div class="pdp-scroll-slide">' + phHtml(Math.abs(i - st.img) <= 1 ? src : null, folienOpt(i)) + '</div>'; }).join('');
        } else {
          Array.prototype.forEach.call(track.children, function (f, i) { phSetzen(f, Math.abs(i - st.img) <= 1 ? liste[i] : null, folienOpt(i)); });
        }
        // Zähler und Punkte
        var zaehler = mainImg.querySelector('.pdp-slide-count'), punkte = mainImg.querySelector('.gallery-dots');
        if (liste.length > 1) {
          if (!zaehler) { zaehler = document.createElement('div'); zaehler.className = 'pdp-slide-count'; scroller.after(zaehler); }
          var z = (st.img + 1) + ' / ' + liste.length; if (zaehler.textContent !== z) zaehler.textContent = z;
          if (!punkte) { punkte = document.createElement('div'); punkte.className = 'gallery-dots'; zaehler.after(punkte); }
          while (punkte.children.length > liste.length) punkte.lastElementChild.remove();
          liste.forEach(function (s, i) {
            var p = punkte.children[i];
            var k = st.img === i ? 'on' : '';
            if (!p) { p = document.createElement('button'); p.className = k; punkte.appendChild(p); }
            if (p.className !== k || !p.hasAttribute('class')) p.className = k;
            p.setAttribute('aria-label', D.name + ' ' + ent(D.ui.ansicht) + ' ' + (i + 1));
            p.setAttribute('aria-pressed', String(st.img === i));
          });
        } else { if (zaehler) zaehler.remove(); if (punkte) punkte.remove(); }
        // Raumbilder (ab 3 Bildern)
        var raum = el.querySelector('.pdp-room-grid');
        if (liste.length >= 3) {
          if (!raum) {
            raum = document.createElement('div'); raum.className = 'pdp-room-grid';
            raum.setAttribute('style', 'display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 10px;');
            raum.innerHTML = '<div style="aspect-ratio: 1 / 1; position: relative; border: 1px solid var(--line); cursor: pointer;"></div><div style="aspect-ratio: 1 / 1; position: relative; border: 1px solid var(--line); cursor: pointer;"></div>';
            mainImg.after(raum); raumKlicks(raum);
          }
          phSetzen(raum.children[0], liste[1], { max: 960, breiten: [360, 540, 720, 960], sizes: '(max-width: 900px) 50vw, 29vw', label: ent(D.ui.imRaum) });
          phSetzen(raum.children[1], liste[2], { max: 960, breiten: [360, 540, 720, 960], sizes: '(max-width: 900px) 50vw, 29vw', label: zctT('v25_bild_detail') || 'DETAIL' });
        } else if (raum) raum.remove();
        zoomZeichnen();
        lightboxZeichnen();
      }
      function aktivSetzen(n) {
        if (n === st.img) return;
        st.img = n;
        galerieZeichnen(false);
        var t = thumbs.children[st.img]; if (t) t.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        vorladen();
      }
      function gehe(ziel) {
        var idx = Math.max(0, Math.min(aktuelle.length - 1, ziel));
        aktivSetzen(idx);
        scroller.scrollTo({ left: scroller.clientWidth * idx, behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      scroller.addEventListener('scroll', function () {
        var n = Math.max(0, Math.min(aktuelle.length - 1, Math.round(scroller.scrollLeft / Math.max(1, scroller.clientWidth))));
        aktivSetzen(n);
      });
      Array.prototype.forEach.call(thumbs.children, function (b) { b.addEventListener('click', function () { gehe(Array.prototype.indexOf.call(thumbs.children, b)); }); });
      mainImg.addEventListener('click', function (e) {
        var p = e.target.closest('.gallery-dots button');
        if (p) { e.stopPropagation(); gehe(Array.prototype.indexOf.call(p.parentNode.children, p)); return; }
        if (e.target.closest('.pdp-scroll-slide')) lightboxAuf();
      });
      function raumKlicks(raum) {
        raum.children[0].addEventListener('click', function () { gehe(1); lightboxAuf(); });
        raum.children[1].addEventListener('click', function () { gehe(2); lightboxAuf(); });
      }
      var raum0 = el.querySelector('.pdp-room-grid'); if (raum0) raumKlicks(raum0);
      // Vorladen des nächsten Bildes (500 ms nach Wechsel)
      var vorladenUhr = null, vorgeladen = {};
      function vorladen() {
        clearTimeout(vorladenUhr);
        var next = aktuelle[st.img + 1]; if (!next) return;
        vorladenUhr = setTimeout(function () {
          var href = url(next, 720); if (vorgeladen[href]) return; vorgeladen[href] = 1;
          try {
            if (document.head.querySelector('link[rel="preload"][as="image"][href="' + CSS.escape(href) + '"]')) return;
            var link = document.createElement('link'); link.rel = 'preload'; link.as = 'image'; link.href = href;
            link.imageSrcset = satz(next, [360, 540, 720, 960, 1200, 1600]); link.imageSizes = '(max-width: 680px) 92vw, (max-width: 1100px) 48vw, 560px';
            link.fetchPriority = 'low'; link.dataset.pdpImagePreload = 'true'; document.head.appendChild(link);
          } catch (e) {}
        }, 500);
      }
      // Zoom
      var zoom = null;
      function zoomZeichnen() {
        var z = mainImg.querySelector('.pdp-zoom');
        if (!zoom) { if (z) z.remove(); return; }
        if (!z) { z = document.createElement('div'); z.className = 'pdp-zoom'; hinweis.before(z); }
        var bg = 'url("' + url(aktuelle[st.img], 2000) + '")';
        z.style.backgroundImage = bg; z.style.backgroundSize = '200%'; z.style.backgroundPosition = zoom.x + '% ' + zoom.y + '%';
      }
      mainImg.addEventListener('mousemove', function (e) { var r = mainImg.getBoundingClientRect(); zoom = { x: (e.clientX - r.left) / r.width * 100, y: (e.clientY - r.top) / r.height * 100 }; zoomZeichnen(); });
      mainImg.addEventListener('mouseleave', function () { zoom = null; zoomZeichnen(); });

      // ---------- Lightbox ----------
      var lb = null, lbX = 0;
      function lightboxAuf() { if (st.lightbox) return; st.lightbox = true; lightboxZeichnen(); document.addEventListener('keydown', lbTaste); document.body.style.overflow = 'hidden'; }
      function lightboxZu() { if (!st.lightbox) return; st.lightbox = false; lightboxZeichnen(); document.removeEventListener('keydown', lbTaste); document.body.style.overflow = ''; }
      function lbTaste(e) {
        if (e.key === 'Escape') lightboxZu();
        if (e.key === 'ArrowRight') aktivSetzen((st.img + 1) % aktuelle.length);
        if (e.key === 'ArrowLeft') aktivSetzen((st.img - 1 + aktuelle.length) % aktuelle.length);
      }
      function lightboxZeichnen() {
        if (!st.lightbox) { if (lb) { lb.remove(); lb = null; } return; }
        if (!lb) {
          lb = document.createElement('div'); lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', D.name);
          lb.innerHTML = '<button class="lb-close" aria-label="' + zctT('schliessen') + '">×</button><button class="lb-nav lb-prev">‹</button><img><button class="lb-nav lb-next">›</button><div class="lb-counter"></div>';
          lb.addEventListener('click', function () { lightboxZu(); });
          lb.querySelector('.lb-close').addEventListener('click', function (e) { e.stopPropagation(); lightboxZu(); });
          lb.querySelector('.lb-prev').addEventListener('click', function (e) { e.stopPropagation(); aktivSetzen((st.img - 1 + aktuelle.length) % aktuelle.length); });
          lb.querySelector('.lb-next').addEventListener('click', function (e) { e.stopPropagation(); aktivSetzen((st.img + 1) % aktuelle.length); });
          var im = lb.querySelector('img');
          im.addEventListener('click', function (e) { e.stopPropagation(); });
          im.addEventListener('touchstart', function (e) { lbX = e.touches[0].clientX; });
          im.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - (lbX || 0); if (Math.abs(dx) > 40) aktivSetzen(dx < 0 ? (st.img + 1) % aktuelle.length : (st.img - 1 + aktuelle.length) % aktuelle.length); });
          el.appendChild(lb);
        }
        var img = lb.querySelector('img'), s = url(aktuelle[st.img], 2000);
        if (img.getAttribute('src') !== s) img.setAttribute('src', s);
        img.setAttribute('alt', alt(st.img));
        lb.querySelector('.lb-counter').textContent = (st.img + 1) + ' / ' + aktuelle.length;
      }

      // ---------- Infos (Oberfläche, Größe, Preis, Texte) ----------
      var info = el.querySelector('.pdp .info');
      function infoZeichnen() {
        var t = ton(), g = groesse();
        // Oberfläche
        var lblTon = info.querySelector('.finish-grid') && info.querySelector('.finish-grid').parentNode.querySelector('.lbl b');
        if (lblTon) lblTon.textContent = D.namen[t];
        info.querySelectorAll('.finish-grid .finish').forEach(function (b, i) { var k = 'finish ' + (st.finish === i ? 'on' : ''); if (b.className !== k) b.className = k; b.setAttribute('aria-pressed', String(st.finish === i)); });
        var slider = el.querySelector('.pdp-tone-slider'); if (slider) slider.style.transform = 'translateX(' + (st.finish * 100) + '%)';
        el.querySelectorAll('.pdp-tone-btn').forEach(function (b, i) { var k = 'pdp-tone-btn' + (st.finish === i ? ' on' : ''); if (b.className !== k) b.className = k; });
        // Kurztext
        var kurz = info.querySelector('p.short');
        if (kurz && !D.v19) { var c = D.texte[t] || {}; kurz.innerHTML = esc(c.desc) + (c.tagline ? ' <em style="color: var(--brass-deep);">' + esc(c.tagline) + '.</em>' : ''); }
        // Größe
        var lblGr = info.querySelector('.size-grid') && info.querySelector('.size-grid').parentNode.querySelector('.lbl b');
        if (lblGr) lblGr.textContent = g.kText;
        sizeBtns.forEach(function (b, i) {
          var s = D.groessen[i], na = s && s.preise && s.preise[t] == null;
          var k = 'size ' + (st.size === i ? 'on' : '') + (na ? ' size-na' : ''); if (b.className !== k) b.className = k;
          // wie React: gesperrt mit Stil; danach bleibt ein leeres style-Attribut stehen
          if (na) { b.disabled = true; b.setAttribute('style', 'opacity: 0.35; cursor: not-allowed;'); } else { b.disabled = false; if (b.hasAttribute('style')) b.setAttribute('style', ''); }
          b.setAttribute('aria-pressed', String(st.size === i));
        });
        // Preis (Wechsel zwischen Preis und „auf Anfrage“ kommt mit den heutigen Daten nicht vor; dann bleibt die
        // Kaufleiste stehen und nur der Betrag wechselt nicht)
        var p = preis();
        var preisEl = info.querySelector('.price');
        var mobil = el.querySelector('.pdp-cta-mobile');
        if (p != null && preisEl.querySelector('.vat')) {
          preisEl.firstChild.nodeValue = fmt(p) + ' ';
          var nEl = info.querySelector('.qbox .n'); if (nEl) nEl.textContent = String(st.qty);
          var kauf = info.querySelector('[data-zct-pdp-kaufen]'); if (kauf) kauf.innerHTML = esc(ent(D.ui.warenkorb)) + ' · ' + esc(fmt(p)) + ' ' + PFEIL;
          var mp = mobil && mobil.querySelector('.price'); if (mp) mp.textContent = fmt(p);
        }
        // Darunter: Beschreibung, Pflege, Maße, Material, Gewicht
        var txt = el.querySelector('[data-zct-pdp-text]');
        if (txt && !D.v19) {
          var c2 = D.texte[t] || {};
          var voll = (c2.desc || '') + (c2.story ? '\n\n' + c2.story : '') + ' ' + ent(D.satz);
          if (voll.indexOf('\n') >= 0) txt.innerHTML = voll.split('\n').filter(Boolean).map(function (a, i) { return '<p style="margin: ' + (i > 0 ? '12px 0px 0px' : '0px') + ';">' + esc(a) + '</p>'; }).join('');
          else txt.textContent = voll;
        }
        var pt = el.querySelector('[data-zct-pdp-pflege-titel]'); if (pt) pt.firstChild.nodeValue = ent(D.pflege[t].titel);
        var px = el.querySelector('[data-zct-pdp-pflege-text]'); if (px) px.textContent = ent(D.pflege[t].text);
        var ma = el.querySelector('[data-zct-pdp-masse]'); if (ma) ma.textContent = g.dimText;
        var mt = el.querySelector('[data-zct-pdp-material]'); if (mt) mt.textContent = D.namen[t];
        var gw = el.querySelector('[data-zct-pdp-gewicht]'); if (gw) gw.textContent = g.gewicht != null ? String(g.gewicht).replace('.', ',') + ' kg' : '—';
      }
      // Wechsel von Oberfläche oder Größe: Bilder neu, Galerie auf Bild 1 (ohne Animation)
      function auswahlGeaendert() {
        var neu = bilder();
        var geaendert = neu.join('|') !== aktuelle.join('|');
        aktuelle = neu;
        st.img = 0;
        scroller.scrollTo({ left: 0, behavior: 'auto' });
        galerieZeichnen(geaendert);
        infoZeichnen();
        vorladen();
      }
      function groesseFuerTon(t) {
        var g = D.groessen[st.size];
        if (g && g.preise && g.preise[t] == null) { var vi = D.groessen.findIndex(function (s) { return s && s.preise && s.preise[t] != null; }); if (vi >= 0) st.size = vi; }
      }
      el.querySelectorAll('.finish-grid .finish').forEach(function (b, i) { b.addEventListener('click', function () { if (st.finish === i) return; st.finish = i; groesseFuerTon(ton()); auswahlGeaendert(); }); });
      el.querySelectorAll('.pdp-tone-btn').forEach(function (b, i) { b.addEventListener('click', function () { if (st.finish === i) return; st.finish = i; groesseFuerTon(ton()); auswahlGeaendert(); }); });
      sizeBtns.forEach(function (b, i) { b.addEventListener('click', function () { var s = D.groessen[i]; if (s && s.preise && s.preise[ton()] == null) return; if (st.size === i) return; st.size = i; auswahlGeaendert(); }); });
      var qbox = el.querySelectorAll('.qbox button');
      if (qbox.length === 2) {
        qbox[0].addEventListener('click', function () { st.qty = Math.max(1, st.qty - 1); infoZeichnen(); });
        qbox[1].addEventListener('click', function () { st.qty = st.qty + 1; infoZeichnen(); });
      }
      // In den Warenkorb (wie handleAdd)
      el.querySelectorAll('[data-zct-pdp-kaufen]').forEach(function (b) {
        b.addEventListener('click', function () {
          var ep = einzelpreis(); if (ep == null || !L.add) return;
          // Vorläufige Zeile gleich mit Shopifys Namen der gewählten Variante (Seitensprache), damit nach der Antwort nichts umspringt
          var v = variante(), standard = v && (v.t === 'Default Title' || v.o1 === 'Default Title');
          L.add({ id: D.id, variantId: v ? v.id : undefined, name: D.titel || D.name, tone: ton(), img: aktuelle[0] || D.bild, price: ep / 100,
            size: v ? (standard ? '' : v.o1 || '') : groesse().k, finish: v ? (standard ? '' : v.o2 || '') : D.namen[ton()], qty: st.qty });
        });
      });
      // Termin (Beratung, Preis anfragen)
      el.querySelectorAll('[data-zct-pdp-termin]').forEach(function (b) { b.addEventListener('click', function () { if (window.zctTermin) window.zctTermin.oeffnen({ name: D.name }); }); });
      // Merken
      var herz = el.querySelector('[data-zct-pdp-merken]');
      function herzZeichnen() {
        if (!herz) return;
        var an = ((L.wish && L.wish()) || []).indexOf(D.id) >= 0;
        var k = 'nav-icon link pdp-wish' + (an ? ' on' : ''); if (herz.className !== k) herz.className = k;
        herz.setAttribute('aria-label', ent(an ? D.ui.entfernen : D.ui.merken));
        herz.style.background = an ? 'var(--paper-3)' : 'transparent';
      }
      if (herz) herz.addEventListener('click', function () { if (L.toggleWish) L.toggleWish(D.id); herzZeichnen(); });
      window.addEventListener('zct:laden', herzZeichnen);
      herzZeichnen();
      // Aufklapper: einer offen oder keiner
      el.querySelectorAll('.pdp-below .acc > button.head').forEach(function (k) {
        k.addEventListener('click', function () {
          var id = k.parentNode.getAttribute('data-zct-acc');
          st.open = st.open === id ? null : id;
          el.querySelectorAll('.pdp-below .acc').forEach(function (a) { var c = 'acc ' + (a.getAttribute('data-zct-acc') === st.open ? 'open' : ''); if (a.className !== c) a.className = c; });
        });
      });

      // Start: nächstes Bild vorladen wie der Effekt in v21. Das scrollIntoView des ersten Vorschaubilds beim Start lassen
      // wir weg: oben auf der Seite bewirkt es nichts, beim Zurückgehen würde es die vom Browser wiederhergestellte Lage verschieben.
      vorladen();
    }
  }
  if (!customElements.get('zct-produkt')) customElements.define('zct-produkt', ZctProdukt);

  /* „NAME im Raum.“ wie PdpInstagram in v21: Beiträge per Shortcode von der Schnittstelle, Karte(n) wie IgCard, Medien erst nahe
     am Bildschirm (200 px / 320 px) über zctInstagram.medium; eine Karte = zweispaltig, mehrere = mittig darunter.
     Ohne v19-Daten erscheint der Bereich erst mit den Beiträgen; mit v19-Daten steht der Text schon vom Server. */
  var HAKEN = '<svg class="ig-verified ig-verified-name" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M22 12l-2.32 2.65.32 3.51-3.43.78-1.8 3.04L12 20.56l-2.77 1.42-1.8-3.04-3.43-.78.32-3.51L2 12l2.32-2.65L4 5.84l3.43-.78 1.8-3.04L12 3.44l2.77-1.42 1.8 3.04 3.43.78-.32 3.51L22 12z"></path><path fill="#fff" d="M10.55 15.7l-3.04-3.04 1.24-1.24 1.8 1.8 4.7-4.7 1.24 1.24-5.94 5.94z"></path></svg>';
  class ZctProduktIg extends HTMLElement {
    connectedCallback() {
      if (this._zct) return; this._zct = true;
      var el = this;
      var codes = (this.getAttribute('data-codes') || '').split(',').filter(Boolean);
      var logo = this.getAttribute('data-logo');
      var api = this.getAttribute('data-api');
      var T = {}; try { T = JSON.parse(this.querySelector('script[data-zct-ig-text]').textContent); } catch (e) {}
      if (!codes.length || !api) return;
      var zeilen = T.v19 ? (Array.isArray(T.zeilen) ? T.zeilen : []) : String(T.zeilen || '').split('\n');
      zeilen = zeilen.map(function (z) { return String(z || '').trim(); }).filter(Boolean);
      function zahl(x) { return Number(x).toLocaleString(zctT('v25_intl_zahl')); }
      function karte(item) {
        return '<div class="ig-card ig-card-static pdp-ig-card" style="cursor: default; --media-ratio: 1;"><div class="ig-top"><img class="ig-avatar" src="' + esc(logo) + '" alt="zincutec" loading="lazy"><span class="ig-user"><b>zincutec' + HAKEN + '</b><small>Instagram</small></span><span class="ig-menu" aria-hidden="true">•••</span></div>' +
          '<div class="ig-media-frame"><span class="ig-media" aria-hidden="true"></span></div>' +
          '<div class="ig-actions" aria-hidden="true"><span class="ig-action-with-count"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.6l-1-1a5.5 5.5 0 00-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 000-7.8z"></path></svg>' + (item.like_count > 0 ? '<b>' + zahl(item.like_count) + '</b>' : '') + '</span>' +
          '<span class="ig-action-with-count"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M21 11.5a8.4 8.4 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.4 8.4 0 01-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.4 8.4 0 013.8-.9h.5a8.5 8.5 0 018 8v.5z"></path></svg>' + (item.comments_count > 0 ? '<b>' + zahl(item.comments_count) + '</b>' : '') + '</span>' +
          '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M22 2L11 13"></path><path d="M22 2l-7 20-4-9-9-4 20-7z"></path></svg></span><span class="ig-save"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"></path></svg></span></div></div>';
      }
      function zeichnen(items) {
        var single = items.length === 1;
        var alt = el.querySelector('.pdp-instagram');
        // Wie React: neu eingefügt mit {} ohne style-Attribut, nach einem Zwischenstand (v19-Text) bleibt style="" stehen
        var textStil = single ? (alt ? ' style=""' : '') : ' style="text-align: center; max-width: 640px; margin: 0px auto;"';
        var absaetze = zeilen.map(function (z, i) { return '<p style="margin: ' + (i > 0 ? '12px 0px 0px' : '0px') + ';">' + (T.v19 ? z : esc(z)) + '</p>'; }).join('');
        var h = '<div class="pdp-instagram" style="padding: 80px 0px;"><div style="max-width: 1200px; margin: 0px auto; padding: 0 var(--gutter); display: grid; grid-template-columns: ' + (single ? '1fr 1fr' : '1fr') + '; gap: ' + (single ? 60 : 48) + 'px; align-items: center;">' +
          '<div class="pdp-ig-text"' + textStil + '>' + (T.kopf || '') +
          '<div style="color: var(--ink-2); line-height: 1.7; max-width: 32em;' + (single ? '' : ' margin: 32px auto 0px;') + '">' + absaetze + '</div></div>' +
          (single ? '<div style="display: flex; justify-content: center;">' + karte(items[0]) + '</div>'
            : '<div class="pdp-ig-grid" style="display: flex; flex-wrap: wrap; gap: 20px; justify-content: center; max-width: 1200px; margin: 0px auto; width: 100%;">' + items.map(karte).join('') + '</div>') +
          '</div></div>';
        var tmp = document.createElement('div'); tmp.innerHTML = h;
        var neu = tmp.firstChild;
        if (alt) alt.replaceWith(neu); else el.appendChild(neu);
        // Medien erst nahe am Bildschirm (DeferredInstagramMedia)
        var karten = neu.querySelectorAll('.pdp-ig-card');
        var beob = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            beob.unobserve(e.target);
            var k = e.target.closest('.pdp-ig-card'), i = Array.prototype.indexOf.call(karten, k), item = items[i];
            if (!item || !window.zctInstagram) return;
            window.zctInstagram.medium(e.target.closest('.ig-media-frame'), item, item.poster, function (w, hh) {
              if (!w || !hh) return; var r = Math.max(0.55, Math.min(1.95, w / hh)); k.style.setProperty('--media-ratio', String(r));
            });
          });
        }, { rootMargin: '200px 320px' });
        neu.querySelectorAll('.ig-media-frame > span.ig-media').forEach(function (s) { beob.observe(s); });
      }
      fetch(api + '?shortcodes=' + encodeURIComponent(codes.join(',')) + '&limit=100&comments=0&pages=25', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (data) {
          var alle = data.items || data.data || [];
          var items = codes.map(function (sc) {
            var m = alle.find(function (i) { return (i.permalink || '').indexOf(sc) >= 0; });
            if (!m) return null;
            var roh = Array.isArray(m.children) ? m.children : (m.children && m.children.data) || [];
            var kinder = roh.map(function (c) { return { id: c.id, src: c.media_url || c.thumbnail_url, poster: c.thumbnail_url || c.media_url, type: c.media_type || 'IMAGE' }; }).filter(function (c) { return c.src; });
            return { id: m.id, type: m.media_type || 'IMAGE', src: m.media_url || m.thumbnail_url, poster: m.thumbnail_url || m.media_url, href: '', caption: m.caption, like_count: m.like_count || 0, comments_count: m.comments_count || 0, children: kinder };
          }).filter(Boolean);
          if (items.length) zeichnen(items);
        }).catch(function () {});
    }
  }
  if (!customElements.get('zct-produkt-ig')) customElements.define('zct-produkt-ig', ZctProduktIg);
})();
